import amex from '../../assets/icons/amex.svg'
import boleto from '../../assets/icons/boleto.svg'
import diners from '../../assets/icons/diners.svg'
import discover from '../../assets/icons/discover.svg'
import elo from '../../assets/icons/elo.svg'
import hipercard from '../../assets/icons/hipercard.svg'
import jcb from '../../assets/icons/jcb.svg'
import martercard from '../../assets/icons/mastercard.svg'
import pix from '../../assets/icons/pix.svg'
import union from '../../assets/icons/union-pay.svg'
import visa from '../../assets/icons/visa.svg'

const UlteisList = [
	{
		title: 'Política de Privacidade',
		link: 'https://oantagonista.com.br/politica-de-privacidade/'
	},
	{
		title: 'Termos de Uso ',
		link: 'https://oantagonista.com.br/termos-de-uso/'
	},
	{
		title: 'Política de Cookies',
		link: 'https://oantagonista.com.br/politica-de-cookies/'
	},
	{
		title: 'Política de Compliance',
		link: 'https://oantagonista.com.br/politica-de-compliance/'
	},
	{
		title: 'Princípios editoriais',
		link: 'https://oantagonista.com.br/principios-editoriais/'
	},
	// {
	// 	title: 'Expediente',
	// 	link: 'https://oantagonista.com.br/expediente/'
	// }
]

const paymentMethods = [
	amex,
	diners,
	discover,
	elo,
	hipercard,
	jcb,
	martercard,
	pix,
	union,
	visa
]

export { UlteisList, paymentMethods }
